import Footer from '@/components/Footer';
import GepdecStory from '@/components/GepdecStory';
import Header from '@/components/Header';
// import TopHeader from '@/components/TopHeader';
import Head from 'next/head';
import React from 'react'
import { Inter } from 'next/font/google';

const inter = Inter({
    subsets: ["latin"],
    weight: ["300", "400", "500", "600", "700", "800", "900"],
    variable: "--font-inter",
});

const LeadershipPage = () => {
    return (
        <div className={inter.variable}>
          <Head>
            <title>PISCESIA Story - Leadership</title>
            <meta name="description" content="Learn about PISCESIA's journey since 2009, our growth in the EPC & Transmission Distribution space, and our vision for the future." />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <link rel="icon" href="/favicon.ico" />
          </Head>
    
          {/* <TopHeader /> */}
          <Header />
          
          <main>
            <GepdecStory />
          </main>
    
          <Footer />
        </div>
      );
}

export default LeadershipPage
